import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

import { useLayout } from '@/composables/core/useLayout';
import { useWallet } from '@/composables/core/useWallet';
import { onBeforeMount } from 'vue';
import HeadingPanel from '@/components/HeadingPanel.vue';
import ConnectWallet from '@/views/errors/ConnectWallet.vue';
import NetworkNotSupported from '@/views/errors/NetworkNotSupported.vue';
import Vesting from '@/views/vesting/Vesting.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { setLayout, layout } = useLayout();
const { checkLocalStorageAndDoAutoLogin, isInjected, isNetworkError } =
  useWallet();

onBeforeMount(() => {
  setLayout();
  checkLocalStorageAndDoAutoLogin();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["content w-full mx-auto flex-grow-1 flex flex-column", _unref(layout)])
  }, [
    _createVNode(HeadingPanel),
    (!_unref(isInjected))
      ? (_openBlock(), _createBlock(ConnectWallet, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_unref(isNetworkError))
            ? (_openBlock(), _createBlock(NetworkNotSupported, {
                key: 0,
                class: "my-auto"
              }))
            : (_openBlock(), _createBlock(Vesting, { key: 1 }))
        ], 64))
  ], 2))
}
}

})